import * as React from 'react'

import { ChevronDown } from 'lucide-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'

interface IProps {
  onClick: () => void
  isEnabled?: boolean
}

export default class SelectButton extends React.PureComponent<IProps> {
  public static defaultProps = {
    isEnabled: true,
  }

  public render() {
    const { isEnabled, onClick } = this.props

    return (
      <Button
        variant="ghost"
        size="icon-xs"
        className="tw:self-center"
        disabled={!isEnabled}
        onClick={onClick}
      >
        <ChevronDown />
      </Button>
    )
  }
}
